import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import Logo from '../components/Logo';

export default function VerifyOtp() {
    const [otp, setOtp] = useState('');
    const [err, setErr] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const { email, type } = location.state || {};

    useEffect(() => {
        if (!email) {
            navigate('/login');
        }
    }, [email, navigate]);

    const handleOtpSubmit = async (e) => {
        e.preventDefault();
        setErr('');
        setLoading(true);
        try {
            const res = await fetch((process.env.REACT_APP_API_URL || '') + '/api/auth/verify-otp', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'ngrok-skip-browser-warning': 'true' },
                body: JSON.stringify({ email, otp, type: type || 'register' })
            });
            const data = await res.json();
            if (!res.ok) throw new Error(data.error || 'Verification failed');

            if (data.token && data.user) {
                localStorage.setItem('token', data.token);
                localStorage.setItem('user', JSON.stringify(data.user));

                // Use window.location.href for a clean reload to the correct dashboard
                if (data.user.role === 'admin') window.location.href = '/admin';
                else if (data.user.role === 'employer') window.location.href = '/employer';
                else window.location.href = '/';
            }
        } catch (err) {
            setErr(err.message);
        } finally {
            setLoading(false);
        }
    };

    const resendOtp = async () => {
        setErr('');
        try {
            const res = await fetch((process.env.REACT_APP_API_URL || '') + '/api/auth/resend-otp', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'ngrok-skip-browser-warning': 'true' },
                body: JSON.stringify({ email })
            });
            if (!res.ok) {
                const data = await res.json();
                throw new Error(data.error || 'Resend failed');
            }
            alert('OTP resent successfully!');
        } catch (err) {
            setErr(err.message);
        }
    };

    return (
        <div className="min-h-screen bg-light flex items-center justify-center relative overflow-hidden px-4 py-20 pt-32">
            <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none">
                <div className="absolute top-[-10%] right-[-10%] w-[40%] h-[40%] bg-primary/5 rounded-full blur-[120px]" />
                <div className="absolute bottom-[-10%] left-[-10%] w-[40%] h-[40%] bg-blue-500/5 rounded-full blur-[120px]" />
            </div>

            <div className="max-w-md w-full relative z-10">
                <div className="text-center mb-8">
                    <Link to="/" className="inline-flex items-center justify-center mb-8 group mx-auto">
                        <Logo variant="dark" size="large" />
                    </Link>
                    <h2 className="text-3xl font-bold text-dark mb-2">Verify Your Identity</h2>
                    <p className="text-body">We've sent a 6-digit code to <span className="text-secondary font-bold">{email}</span></p>
                </div>

                <div className="bg-white rounded-3xl p-8 md:p-10 shadow-card border border-gray-100">
                    <form onSubmit={handleOtpSubmit} className="space-y-6 relative z-10 animate-fade-in-up">
                        <div>
                            <label className="block text-sm font-bold text-dark mb-2">Enter 6-Digit OTP</label>
                            <input
                                required
                                maxLength="6"
                                value={otp}
                                onChange={e => setOtp(e.target.value.replace(/\D/g, ''))}
                                placeholder="000000"
                                className="w-full px-5 py-4 bg-gray-50 border border-gray-200 rounded-xl text-center text-3xl font-bold tracking-[10px] text-dark placeholder-gray-300 focus:ring-4 focus:ring-primary/10 focus:border-primary outline-none transition-all hover:bg-white"
                                autoFocus
                            />
                        </div>

                        {err && <div className="p-4 bg-red-50 border border-red-100 rounded-xl text-red-500 text-sm text-center font-bold">{err}</div>}

                        <button
                            type="submit"
                            disabled={loading}
                            className="w-full py-4 bg-primary text-white font-bold rounded-xl hover:bg-blue-700 transition-all shadow-button hover:-translate-y-1 disabled:opacity-50"
                        >
                            {loading ? 'Verifying...' : 'Verify & Complete'}
                        </button>

                        <div className="text-center space-y-4">
                            <button
                                type="button"
                                onClick={resendOtp}
                                className="text-primary font-bold hover:underline transition-colors block w-full"
                            >
                                Didn't receive code? Resend
                            </button>
                            <Link to="/login" className="text-body text-sm font-bold hover:text-dark transition-colors inline-block">
                                Back to Login
                            </Link>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
